import React from "react"
import { Link } from "gatsby"
import SbEditable from "storyblok-react"
import Socials from "../Socials"
import TextRenderer from "../TextRenderer"

import LogoSvg from "./../../graphics/logo.svg"

import styles from "./styles.module.scss"

const Footer = (props) => {
  return (
    <footer className={styles["footer"]}>
      <Link
        to="/donate"
        className={`button heading-4 ${styles["footer__donate"]}`}
      >
        Donate
      </Link>
      <div className={styles["footer__inner"]}>
        <div className={`container ${styles["footer__menu"]}`}>
          <div className={`row ${styles["footer__row"]}`}>
            {props.blok.footer_columns &&
              props.blok.footer_columns.map((blok) => {
                return (
                  <SbEditable content={blok} key={blok._uid}>
                    <div className={`col ${styles["footer-item__column"]}`}>
                      <h4
                        className={`heading-5 ${styles["footer-item__heading"]}`}
                      >
                        <b>{blok.heading}</b>
                      </h4>
                      <TextRenderer
                        text={blok.copy}
                        className={styles["footer-item__text"]}
                      />
                    </div>
                  </SbEditable>
                )
              })}
            <div className={`col ${styles["footer-item__logo-col"]}`}>
              <Link className={styles["footer-item__logo-link"]} to="/">
                <LogoSvg className={styles["footer-item__logo"]} />
              </Link>
            </div>
          </div>
        </div>
        <div className="container">
          <div className={`row ${styles["footer-bottom__row"]}`}>
            <div
              className={`col col-12 col-sm-9 ${styles["footer-bottom__company"]}`}
            >
              <div className={styles["footer-bottom__partners"]}>
                {props.blok.footer_partners &&
                  props.blok.footer_partners.map((blok, i) => {
                    return (
                      <SbEditable key={i} content={blok}>
                        <a
                          className={styles["footer-bottom__partner-link"]}
                          href={blok.link.url}
                          target="_blank"
                        >
                          <img
                            className={styles["footer-bottom__partner-logo"]}
                            src={blok.logo.filename}
                            alt={blok.logo.alt}
                          />
                        </a>
                      </SbEditable>
                    )
                  })}
              </div>
              <Link
                className={`body ${styles["footer-bottom__link"]}`}
                to="/privacy-policy"
              >
                Equity &amp; Privacy Policies
              </Link>
            </div>
            <div
              className={`col col-12 col-sm-3 ${styles["footer-bottom__contact"]}`}
            >
              {props.blok.social_items && (
                <Socials
                  className={styles["footer-bottom__socials"]}
                  items={props.blok.social_items}
                  showEmail
                />
              )}
              <span className="body">Our EIN: 26-0642778</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
